import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAdmin } from "../../utils/auth";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [authed, setAuthed] = useState(() => isAdmin());

  useEffect(() => {
    const sync = () => setAuthed(isAdmin());
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
